import {ProcessorField} from './ProcessorField';
import {ProcessorOperation} from './ProcessorOperation';
import {Table} from '../../workingtable/message/Table';

export class CnxProcessor {
fields: ProcessorField[];
fieldsMap: {[key: string]: ProcessorField};
operations: ProcessorOperation[];
orderedOperations: ProcessorOperation[];
orderedfields: ProcessorField[];
processorInTables: {[key: string]: Table};
processorOutTables: {[key: string]: Table};
}

